import {
  CloudOutlined,
  ClusterOutlined,
  FireOutlined,
  FileDoneOutlined,
  InboxOutlined,
  ProfileOutlined,
} from '@ant-design/icons';
import { DimaContext } from '../../DimaContext';
import { Col, Row, Space } from 'antd';
import { Link } from 'react-router-dom';
import React, { useContext } from 'react';

const HeaderMenu = props => {
  const context = useContext(DimaContext);
  const spaceSize = 'large';

  return (
    <>
      <span style={{ float: 'left', marginRight: 20, marginLeft: 20 }}>
        <a href="/" style={{ color: 'white' }}>
          1UpHealth
        </a>
      </span>
      <Row className="header-nav-custom" justify="space-between" gutter={[24, 24]} wrap={false}>
        <Col>
          <Space size={spaceSize}>
            {(!!window.localStorage.getItem('user_email') ||
              !!process.env.REACT_APP_HOST.includes('localhost')) && (
              <a href="/">
                <InboxOutlined /> Clients
              </a>
            )}

            <a href="/validate/file">
              <ProfileOutlined /> File Extract Guides
            </a>
            <a href="/validate/fhir">
              <FireOutlined /> FHIR Validator
            </a>

            
              <a href="/dataContracts">
                <FileDoneOutlined/> Data Contracts
              </a>

            {context.userData.authenticated && (
                <a href="/hl7-validation-rules">
                <ProfileOutlined /> HL7v2 Validation Rules
              </a>
            )}
              
            {process.env.REACT_APP_FEATURE_HL7_DATA_GUIDE && (
              <a href="/hl7DataGuide">
                <ProfileOutlined/> HL7v2 Data Guide
              </a>
            )}
          </Space>
        </Col>
        <Col offset={-1}>
          <Space size={spaceSize}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://1uphealth.atlassian.net/wiki/spaces/Connect/pages/144834564/User+Guide"
            >
              Docs
            </a>
            {context.client != null && props.isMappingView && (
              <span style={{ cursor: 'pointer' }}>
                <CloudOutlined /> &nbsp; {context.client.name}
              </span>
            )}
            {window.localStorage.getItem('user_email') && (
              <span
                style={{
                  color: 'white',
                  cursor: 'pointer',
                }}
              >
                {window.localStorage.getItem('user_email')}
              </span>
            )}
          </Space>
        </Col>
      </Row>
    </>
  );
};

export default HeaderMenu;
